export const GET_PROJECT_SERVICES = 'GET_PROJECT_SERVICES';

export const TOGGLE_LOGIN = 'TOGGLE_LOGIN';

export const USER_LOGIN = 'USER_LOGIN';

export const USER_UPDATE = 'USER_UPDATE';
